import { Injectable } from '@angular/core';
import { GET, POST } from 'src/app/network/network.service';
@Injectable({
    providedIn: 'root'
})

export class InfoService {
    token = localStorage.getItem('token');

    constructor() { }

    @POST('admin/schools/:schoolId')
    updateSchoolInfo(body: any) {
        return undefined as any;
    }

    @GET('admin/schools/:schoolId/statistics')
    getSchoolStat() {
        return undefined as any;
    }
}